// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "mainSite." + ({"32":"projectCarousel","557":"heroCarousel"}[chunkId] || chunkId) + "." + {"32":"08b5c2af0b0525e38005","376":"d23ca349fbc229f502aa","557":"08b5c2af0b0525e38005"}[chunkId] + ".css";
};